import { ArrowLeft } from "@untitledui/icons";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/base/buttons/button";
import { useAuth } from "@/context/AuthContext";
import { getDefaultAuthenticatedPath } from "@/utils/permissions";

export default function NotFound() {
	const navigate = useNavigate();
	const { user, loading } = useAuth();
	const [countdown, setCountdown] = useState(10);
	const authenticatedFallbackPath = user
		? getDefaultAuthenticatedPath(user.role)
		: "/login";

	useEffect(() => {
		const timer = setInterval(() => {
			setCountdown((prev) => Math.max(prev - 1, 0));
		}, 1000);

		return () => clearInterval(timer);
	}, []);

	useEffect(() => {
		if (countdown === 0) {
			navigate(authenticatedFallbackPath, { replace: true });
		}
	}, [authenticatedFallbackPath, countdown, navigate]);

	if (loading) {
		return (
			<div className="flex min-h-screen items-center justify-center bg-primary text-white">
				Carregando...
			</div>
		);
	}

	return (
		<section className="flex min-h-screen items-center justify-center bg-primary px-4 py-16">
			<div className="flex max-w-2xl flex-col gap-6 text-center">
				<span className="font-semibold text-brand-secondary text-md">
					404 error
				</span>
				<h1 className="font-bold text-4xl text-brand-secondary md:text-5xl">
					Página não encontrada
				</h1>
				<p className="text-gray-300 text-lg md:text-xl">
					A página que você está procurando não existe ou foi movida. Você será
					redirecionado automaticamente.
				</p>
				<p className="font-semibold text-brand-secondary text-lg md:text-xl">
					{countdown} segundos restantes
				</p>

				<div className="mt-6 flex flex-col justify-center gap-3 sm:flex-row">
					<Button
						color="secondary"
						iconLeading={ArrowLeft}
						onClick={() =>
							navigate(authenticatedFallbackPath, { replace: true })
						}
						size="xl"
					>
						{user ? "Voltar ao Dashboard" : "Voltar ao login"}
					</Button>
				</div>
			</div>
		</section>
	);
}
